<template>
  <v-layout>
    <v-flex md8>
      <div id="dfs-chat"></div>
    </v-flex>
  </v-layout>
</template>

<script>
  import resourcesMixins from '@/mixins/Resources'
  import SendBird from 'sendbird' // eslint-disable-line no-unused-vars
  import LiveChat from '@/livechat/js/chat'
  import casesAPI from '@/api/resources/cases'
  import crudAPI from '@/api/resources/crud'

  export default {
    name: 'CaseFormsChat',
    props: {
      casesid: {
        type: Number,
        required: true
      }
    },
    mixins: [ resourcesMixins ],
    data () {
      return {
        resources: 'chats',
        createdChannelUrl: '',
        userId: this.$store.getters.loggedUserEmail,
        chat: {}
      }
    },
    computed: {
      channelName () {
        return 'dfs_chat_' + this.casesid
      }
    },
    watch: {
      createdChannelUrl () {
        this.chat.enterChannel(this.createdChannelUrl)
      }
    },
    methods: {
      loadListing () {

      }
    },
    mounted () {
      this.chat = new LiveChat()

      window.liveChat = this.chat
      window.SendBird = SendBird

      let el = document.createElement('div')

      el.setAttribute('id', 'sb_chat')
      el.setAttribute('class', 'content-chat')

      let dfsChat = document.getElementById('dfs-chat')

      dfsChat.appendChild(el)

      this.chat.startWithConnect(this.$dfsConfig.sendbird_app_id, this.userId, this.userId, () => {
        casesAPI.getLinkedChat(this.casesid).then(result => {
          this.createdChannelUrl = result.url
        }, error => {
          let handle = error // eslint-disable-line

          this.chat.adapter.api.OpenChannel.createChannel(this.channelName, '', '', (createdChannel, error) => {
            if (error) {
              console.log('can\'t create channel')

              return
            }

            this.createdChannelUrl = createdChannel.url

            let payload = {
              url: createdChannel.url
            }

            crudAPI.dfsResourceStore(this.resources + '/withid', payload).then(result => {
              casesAPI.attachChatToCase(this.casesid, result.data.additional_data.inserted_id).then(result => {
                // console.log(result)
              }, () => {})
            }, error => {
              let handle = error // eslint-disable-line
            })
          })
        })
      })
    }
  }
</script>

<style>
  .content-chat {
    width: 100%;
    height: 100%;
  }
  #dfs-chat .chat-board .message-board .content {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// CaseFormsChat.vue?7f3e9d50